import React from "react";
import { Box, Typography } from "@mui/material";
import WorkflowPifSelectField from "./WorkflowPifSelectField";
import WorkflowPifTextField from "./WorkflowPifTextField";
import { PifSectionProps, pifRateMessage, pifRateTone } from "./pifDetailsModel";
import { PIF_DETAILS_FIELDS } from "./pifWorkflowKeys";
import { isPifStartDatePast } from "../../pages/supervision/PostInterviewForm/pifValidation";

const F = PIF_DETAILS_FIELDS;

/** pif-3 Compensation. The rate is compared with the band and flagged, never blocked (3.1, AC6). */
const WorkflowPifPaySection: React.FC<PifSectionProps> = ({ values, errors, reference, onChange }) => {
  const field = { values, errors, onChange };
  return (
    <>
      <Typography component="h3" className="workflow-run__section-title">
        Compensation
      </Typography>
      <Box className="workflow-run__grid">
        <WorkflowPifTextField
          {...field}
          fieldKey={F.rate}
          label="Rate (USD/hr)"
          type="number"
          inputMode="decimal"
          required
          hint={pifRateMessage(values[F.rate] ?? "", reference.band, Boolean(values[F.position]))}
          hintTone={pifRateTone(values[F.rate] ?? "", reference.band)}
        />
        <WorkflowPifSelectField
          {...field}
          fieldKey={F.rateType}
          label="Rate type"
          options={reference.rateTypes}
          placeholder="Choose a rate type…"
          required
        />
        <WorkflowPifTextField
          {...field}
          fieldKey={F.approverNotes}
          label="Notes for the approvers"
          multiline
          maxLength={1000}
          required={isPifStartDatePast(values[F.firstWorkingDay] ?? "")}
        />
      </Box>
    </>
  );
};

export default WorkflowPifPaySection;
